import { FilterBridgeService } from './../../../filtro-magico/services/filter-bridge/filter-bridge.service';
import { FiltroMostrar } from './interfaces/filtro-mostrar.interface';
import { DateService } from '../../../../services/dateService/date.service';
import { FiltrosMagicos } from '../../../filtro-magico/interfaces/filtro-magico.interface';
import { Component, OnInit, Input, OnChanges } from '@angular/core';
import { v4 as uuidv4 } from 'uuid';

@Component({
  selector: 'app-datatable-filtro-lista',
  templateUrl: './datatable-filtro-lista.component.html',
  styleUrls: ['./datatable-filtro-lista.component.scss']
})
export class DatatableFiltroListaComponent implements OnInit, OnChanges {
  @Input('id') id: string;
  @Input() filtros: any;
  @Input() filtrosMagicos: FiltrosMagicos;
  @Input() rebuild: boolean = false;

  internalId: string;

  filtrosMostrar: FiltroMostrar[] = [];

  constructor(private dateService: DateService, private filterBridgeService: FilterBridgeService) {
    this.internalId = uuidv4();
  }

  ngOnInit(): void {}

  ngOnChanges() {
    this.convertToArray();
  }

  removeFilter(filtroMostrar: FiltroMostrar) {
    const resp = this.removeFilterFromList(filtroMostrar);
    this.filterBridgeService.pushFilter(
      this.id,
      this.internalId,
      resp.filtroModel,
      resp.filtroBind,
      null
    );
  }

  removeFilterFromList(filtroMostrar: FiltroMostrar) {
    const f = filtroMostrar;
    const key = filtroMostrar.key;

    let filtroModel = {};
    let filtroBind = {};

    if (f.tipo === 'select' || f.tipo === 'producto') {
      filtroModel[key] = null;
      filtroBind[key] = null;
    } else if (
      f.tipo === 'select-multiple' ||
      f.tipo === 'producto-multiple' ||
      f.tipo === 'select-search-multiple'
    ) {
      filtroModel[key] = [];
      filtroBind[key] = [];
    } else if (f.tipo === 'rango-fechas') {
      let llamarFiltro = this.getFlagLlamarFiltroFecha(filtroMostrar.filtro);
      filtroBind[key] = { desde: null, hasta: null, llamarFiltro: llamarFiltro };
      filtroModel[key] = { desde: null, hasta: null };
    } else if (f.tipo === 'dropdown-input') {
      filtroModel[key] = { dropdown: filtroMostrar.filtro.dropdown, valor: null };
      filtroBind[key] = null;
    } else if (f.tipo === 'search') {
      filtroModel[key] = null;
      filtroBind[key] = null;
    } else if (f.tipo === 'dropdown-select-multiple') {
      filtroModel[key] = { dropdown: filtroMostrar.filtro.dropdown, valor: [] };
      filtroBind[key] = [];
    }

    return { filtroModel, filtroBind };
  }

  removeAll() {
    const data = this.filtrosMostrar.map(f => this.removeFilterFromList(f));
    const filtrosModel = data.map(r => r.filtroModel);
    const filtrosBind = data.map(r => r.filtroBind);
    this.filterBridgeService.pushFilter(this.id, this.internalId, filtrosModel, filtrosBind, null);
  }

  getFlagLlamarFiltroFecha(filtro): boolean {
    if (filtro.desde !== null && filtro.hasta !== null) {
      return true;
    }
    return false;
  }

  convertToArray() {
    this.filtrosMostrar = [];
    Object.keys(this.filtros).forEach(key => {
      if (this.filtros[key]) {
        const filtroMagico = this.filtrosMagicos.filtros.filter(x => x.key === key)[0];
        let filtroMostrar = {
          key: filtroMagico.key,
          tipo: filtroMagico.tipo,
          label: filtroMagico.nombre,
          filtro: this.filtros[key]
        };
        let value = '';
        let addFiltro = true;
        if (filtroMagico.tipo === 'select') {
          value = filtroMagico.opcionSelect(this.filtros[key]);
        } else if (
          filtroMagico.tipo === 'select-multiple' &&
          this.filtros[key] &&
          this.filtros[key].length > 0
        ) {
          value = this.filtros[key].map(f => filtroMagico.opcionSelect(f)).join(',');
        } else if (
          filtroMagico.tipo === 'rango-fechas' &&
          (this.filtros[key].desde || this.filtros[key].hasta)
        ) {
          if (this.filtros[key].desde && !this.filtros[key].hasta) {
            value = '>=' + this.dateService.fechaADDMMYYYY(this.filtros[key].desde);
          } else if (!this.filtros[key].desde && this.filtros[key].hasta) {
            value = '<=' + this.dateService.fechaADDMMYYYY(this.filtros[key].hasta);
          } else if (this.filtros[key].desde && this.filtros[key].hasta) {
            value =
              this.dateService.fechaADDMMYYYY(this.filtros[key].desde) +
              ' - ' +
              this.dateService.fechaADDMMYYYY(this.filtros[key].hasta);
          }
        } else if (filtroMagico.tipo === 'producto') {
          value = this.filtros[key].sku;
        } else if (filtroMagico.tipo === 'search') {
          value = this.filtros[key];
        } else if (
          filtroMagico.tipo === 'producto-multiple' &&
          this.filtros[key] &&
          this.filtros[key].length > 0
        ) {
          value = this.filtros[key].map(f => f.sku).join(',');
        } else if (
          filtroMagico.tipo === 'select-search-multiple' &&
          this.filtros[key] &&
          this.filtros[key].length > 0
        ) {
          value = this.filtros[key].map(f => f[filtroMagico.valoresSelectSearchKey]).join(',');
        } else if (
          filtroMagico.tipo === 'dropdown-input' &&
          (this.filtros[key].valor || this.filtros[key] === 0 || this.filtros[key] === '0')
        ) {
          value =
            filtroMagico.opcionDropdown(this.filtros[key].dropdown) + ' ' + this.filtros[key].valor;
        } else if (
          filtroMagico.tipo === 'dropdown-select-multiple' &&
          this.filtros[key].valor &&
          this.filtros[key].valor.length > 0
        ) {
          value =
            '[' +
            filtroMagico.opcionDropdown(this.filtros[key].dropdown) +
            '] ' +
            this.filtros[key].valor.map(f => filtroMagico.opcionSelect(f)).join(',');
        } else {
          addFiltro = false;
        }
        if (addFiltro) {
          this.filtrosMostrar.push({ ...filtroMostrar, value });
        }
      }
    });
  }
}
